export function onUploadProgress(progressEvent) {
  this.setState({
    uploadPercent: Math.round((progressEvent.loaded * 100) / progressEvent.total),
  });
}

export function toggleState(name) {
  return () => {
    this.setState((state) => {
      const { [name]: value } = state;
      return {
        [name]: !value,
      };
    });
  };
}

export function updateFieldInState(fieldName, value) {
  return () => {
    this.setState(() => {
      return{
        [fieldName]: value
      };
    });
  };
}
export function handleSelectAll(getElements, context) {
  return function (event) {
    const { target: { checked } } = event;
    const list = getElements();
    if (checked) {
      this.setState({
        selectedIds: list.map(elem => elem.id),
      });
    } else {
      this.setState({
        selectedIds: [],
      });
    }
  }.bind(context);
}

export function handleElementSelect(id) {
  return (event) => {
    const { target: { checked } } = event;
    const { selectedIds } = this.state;
    if (checked && !selectedIds.includes(id)) {
      this.setState({
        selectedIds: [...selectedIds, id],
      });
    } else {
      this.setState({
        selectedIds: selectedIds.filter(curId => curId !== id),
      });
    }
  };
}

export function getContactFromConversation(conversation) {
  return {
    id: conversation.userId,
    firstName: conversation.userFirstName,
    lastName: conversation.userLastName,
    visitorEmail: conversation.visitorEmail,
    visitorPhoneNumber: conversation.visitorPhoneNumber,
    platform: conversation.platform,
    platformId: conversation.userPlatformId,
    thumbUrl: conversation.userThumbUrl,
    bot: undefined,
  };
}

export function handleChange(name) {
  return (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };
}

export function handleValueChange(name) {
  return (value) => {
    this.setState({
      [name]: value,
    });
  };
}



// WEBPACK FOOTER //
// ./src/utils/ComponentUtilFunctions.js